function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".log-out_svg__cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:.25px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "log-out_svg__cls-1",
  d: "M.147 5.85h7.529M.31 7.214a5.703 5.703 0 100-2.727"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "log-out_svg__cls-1",
  d: "M5.442 8.084L7.676 5.85 5.442 3.616"
});

function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "log-out_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLogOut;